export enum PostProgressStatusTypes {
  BACKLOG = 'BACKLOG',
  IN_PROGRESS = 'IN_PROGRESS',
  IN_REVIEW = 'IN_REVIEW',
  BLOCKED = 'BLOCKED',
  REJECTED = 'REJECTED',
  DISCARDED = 'DISCARDED',
  DONE = 'DONE',
}
